import { render, staticRenderFns } from "./ModalRequisitioners.vue?vue&type=template&id=10a9d3e8&lang=pug&"
import script from "./ModalRequisitioners.vue?vue&type=script&lang=js&"
export * from "./ModalRequisitioners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports